<nav mat-tab-nav-bar [color]="'accent'">
  <a mat-tab-link (click)="filtrer()" [active]="!activeBetaler">
    Alle posteringer&nbsp;
    <span>{{ posteringsLinjer.length }}</span>
  </a>
  @for (betaler of betalere; track betaler) {
    <a
      mat-tab-link
      (click)="filtrer(betaler.id)"
      [active]="activeBetaler === 1"
      [disabled]="posteringsCount(betaler.id) < 1"
      >
      {{ betaler.text }}&nbsp;
      <span>{{ posteringsCount(betaler.id) > 0 ? posteringsCount(betaler.id) : '' }}</span>
    </a>
  }
</nav>

<table [class.expanded]="_isExpanded" mat-table [dataSource]="dataSource" class="mat-elevation-z0" multiTemplateDataRows>
  <ng-container matColumnDef="Varenr">
    <th mat-header-cell *matHeaderCellDef [attr.colspan]="3" class="align-center">Varenr</th>
  </ng-container>

  <ng-container matColumnDef="placeholder">
    <th mat-header-cell *matHeaderCellDef [attr.colspan]="_isExpanded ? 3 : 5"></th>
  </ng-container>

  <ng-container matColumnDef="partnerVareNr">
    <th mat-header-cell *matHeaderCellDef>Partner</th>
    <td mat-cell *matCellDef="let posteringsLinje">
      <div>{{ posteringsLinje.partnerVarenr ? posteringsLinje.partnerVarenr : '-' }}</div>
    </td>
    <td mat-footer-cell *matFooterCellDef class="bold">Total</td>
  </ng-container>

  <ng-container matColumnDef="partnerMatch">
    <th mat-header-cell *matHeaderCellDef>Automatch</th>
    <td mat-cell *matCellDef="let posteringsLinje">
      <div>
        @if (posteringsLinje.varenrDefaultedToDiverse) {
          <mat-icon
            matTooltip="Partnervarenr er IKKE genkendt"
            aria-hidden="false"
            class="red"
            aria-label="Partnervarenr er IKKE genkendt"
            >
            not_interested
          </mat-icon>
        }
        @if (!posteringsLinje.varenrDefaultedToDiverse) {
          <mat-icon
            matTooltip="Partnervarenr er genkendt"
            aria-hidden="false"
            class="green"
            aria-label="Partnervarenr er genkendt"
            matTooltip="Partnervarenr er genkendt"
            >
            merge_type
          </mat-icon>
        }
      </div>
    </td>
    <td mat-footer-cell *matFooterCellDef class="bold">@if (!_isExpanded) {
      <span>Total</span>
    }</td>
  </ng-container>

  <ng-container matColumnDef="okKundeVarenr">
    <th class="min-col" mat-header-cell *matHeaderCellDef [attr.rowspan]="2">
      {{ _isExpanded ? 'OK' : 'Varenr' }}
    </th>
    <td mat-cell *matCellDef="let posteringsLinje">
      <div>
        <span
          class="ellipsis"
          [matTooltip]="
            posteringsLinje.partnerVarenr ? 'Partners Varenr: ' + posteringsLinje.partnerVarenr : 'Intet partner varenr angivet'
          "
          >
          {{ posteringsLinje.okKundeVarenr }}
        </span>
      </div>
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <ng-container matColumnDef="produkt">
    <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2">Produkt</th>
    <td mat-cell *matCellDef="let posteringsLinje">
      <div>{{ posteringsLinje.produkt }}</div>
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <ng-container matColumnDef="antal">
    <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2">Antal</th>
    <td mat-cell *matCellDef="let posteringsLinje">
      <div>{{ posteringsLinje.antal }}</div>
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <ng-container matColumnDef="Enhedspris">
    <th mat-header-cell *matHeaderCellDef [attr.colspan]="2">Enhedspris</th>
  </ng-container>

  <ng-container matColumnDef="stkPrisExclMoms">
    <th mat-header-cell *matHeaderCellDef class="align-right cursor-help" matTooltip="Styk pris ekskl. moms">
      <span [class.grey-prio]="!isErhverv" [class.black]="isErhverv">Ekskl. moms</span>
    </th>
    <td mat-cell *matCellDef="let posteringsLinje" class="align-right">
      @if (!activeBetaler && posteringsLinje.betaler?.id === 3) {
        <span class="ub"><strong>U/B</strong></span>
      }
      <span
        class="cursor-help"
        [class.grey-prio]="!isErhverv"
        [class.black]="isErhverv"
        matTooltip="{{ this.getToolTip('unitPriceNet', posteringsLinje) }}"
        >
        {{ posteringsLinje.stkPrisExclMoms | dkCurrency }}
      </span>
    </td>
    <td mat-footer-cell *matFooterCellDef class="align-right">
      @if (!_isExpanded) {
        <span
          [class.grey-prio]="!isErhverv"
          [class.bold]="isErhverv"
          matTooltip="{{ this.getToolTip('totalPriceNet', null) }}"
          >
          {{ saldo | dkCurrency }}
        </span>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="stkPrisInclMoms">
    <th mat-header-cell *matHeaderCellDef class="align-right cursor-help" matTooltip="Styk pris inkl. moms">
      <span [class.grey-prio]="isErhverv" [class.black]="!isErhverv">Inkl. moms</span>
    </th>
    <td mat-cell *matCellDef="let posteringsLinje" class="align-right">
      @if (!activeBetaler && posteringsLinje.betaler?.id === 3) {
        <span class="ub"><strong>U/B</strong></span>
      }
      <span
        class="cursor-help"
        [class.grey-prio]="isErhverv"
        [class.black]="!isErhverv"
        matTooltip="{{ this.getToolTip('unitPriceGross', posteringsLinje) }}"
        >
        {{ posteringsLinje.stkPrisInclMoms | dkCurrency }}
      </span>
    </td>
    <td mat-footer-cell *matFooterCellDef class="align-right">
      @if (!_isExpanded) {
        <span
          [class.grey-prio]="isErhverv"
          [class.bold]="!isErhverv"
          matTooltip="{{ this.getToolTip('totalPriceGross', null) }}"
          >
          {{ saldoInclMoms | dkCurrency }}
        </span>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="Totalpris">
    <th mat-header-cell *matHeaderCellDef [attr.colspan]="2">Beløb</th>
  </ng-container>

  <ng-container matColumnDef="totalPrisExclMoms">
    <th mat-header-cell *matHeaderCellDef class="align-right cursor-help" matTooltip="Samlet beløb ekskl. moms">
      <span [class.grey-prio]="!isErhverv" [class.black]="isErhverv">Ekskl. moms</span>
    </th>
    <td mat-cell *matCellDef="let posteringsLinje" class="align-right">
      @if (!activeBetaler && posteringsLinje.betaler?.id === 3) {
        <span class="ub"><strong>U/B</strong></span>
      }
      <span [class.grey-prio]="!isErhverv" [class.black]="isErhverv">
        {{ posteringsLinje.totalPrisExclMoms | dkCurrency }}
      </span>
    </td>
    <td mat-footer-cell *matFooterCellDef class="align-right">
      @if (_isExpanded) {
        <span
          [class.grey-prio]="!isErhverv"
          [class.bold]="isErhverv"
          matTooltip="{{ this.getToolTip('totalPriceNet', null) }}"
          >
          {{ saldo | dkCurrency }}
        </span>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="totalPrisInclMoms">
    <th mat-header-cell *matHeaderCellDef class="align-right cursor-help" matTooltip="Samlet beløb inkl. moms">
      <span [class.grey-prio]="isErhverv" [class.black]="!isErhverv">Inkl. moms</span>
    </th>
    <td mat-cell *matCellDef="let posteringsLinje" class="align-right">
      @if (!activeBetaler && posteringsLinje.betaler?.id === 3) {
        <span class="ub"><strong>U/B</strong></span>
      }
      <span [class.grey-prio]="isErhverv" [class.black]="!isErhverv">
        {{ posteringsLinje.totalPrisInclMoms | dkCurrency }}
      </span>
    </td>
    <td mat-footer-cell *matFooterCellDef class="align-right">
      @if (_isExpanded) {
        <span
          [class.grey-prio]="isErhverv"
          [class.bold]="!isErhverv"
          matTooltip="{{ this.getToolTip('totalPriceGross', null) }}"
          >
          {{ saldoInclMoms | dkCurrency }}
        </span>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="rowMenu">
    <th mat-header-cell class="row-menu" *matHeaderCellDef [attr.rowspan]="2"></th>
    <td mat-cell *matCellDef="let posteringsLinje; index as i">
      @if (editable) {
        <button mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>
      }
      <mat-menu #menu="matMenu">
        <button mat-menu-item [matMenuTriggerFor]="betaler">
          <mat-icon svgIcon="avatar"></mat-icon>
          Angiv betaler
        </button>
        @if (editable) {
          <button mat-menu-item (click)="linjeEdited.emit(posteringsLinje)">
            <mat-icon svgIcon="edit"></mat-icon>
            Rediger postering
          </button>
        }
        @if (editable) {
          <button mat-menu-item (click)="linjeDeleted.emit(posteringsLinje)">
            <mat-icon svgIcon="delete"></mat-icon>
            Slet postering
          </button>
        }

        <button mat-menu-item [cdkCopyToClipboard]="copyPosteringsLinje(posteringsLinje)">
          <mat-icon class="icon-18">content_copy</mat-icon>
          Kopier
        </button>
      </mat-menu>
      <mat-menu #betaler="matMenu">
        @for (betaler of betalere; track betaler) {
          <button
            mat-menu-item
            (click)="garanti(posteringsLinje, betaler)"
            [disabled]="posteringsLinje.betaler?.id === betaler.id"
            >
            {{ betaler.text }}
          </button>
        }
      </mat-menu>
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <ng-container matColumnDef="rowMenu-expanded">
    <th mat-header-cell class="row-menu" *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let posteringsLinje; index as i" class="align-right">
      @if (editable) {
        <button mat-icon-button (click)="linjeEdited.emit(posteringsLinje)" [matTooltip]="'Rediger rækken'">
          <mat-icon svgIcon="edit"></mat-icon>
        </button>
      }
      @if (editable) {
        <button mat-icon-button (click)="linjeDeleted.emit(posteringsLinje)" [matTooltip]="'Slet rækken'">
          <mat-icon svgIcon="delete"></mat-icon>
        </button>
      }

      <button mat-icon-button [cdkCopyToClipboard]="copyPosteringsLinjeExpanded(posteringsLinje)" [matTooltip]="'Kopiér data række'">
        <mat-icon>content_copy</mat-icon>
      </button>

      @if (editable) {
        <button mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>
      }
      <mat-menu #menu="matMenu">
        <button mat-menu-item [matMenuTriggerFor]="betaler">
          <mat-icon svgIcon="avatar"></mat-icon>
          Angiv betaler
        </button>
      </mat-menu>
      <mat-menu #betaler="matMenu">
        @for (betaler of betalere; track betaler) {
          <button
            mat-menu-item
            (click)="garanti(posteringsLinje, betaler)"
            [disabled]="posteringsLinje.betaler?.id === betaler.id"
            >
            {{ betaler.text }}
          </button>
        }
      </mat-menu>
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <ng-container matColumnDef="N/A">
    <td mat-cell *matCellDef="let posteringsLinje" [attr.colspan]="_isExpanded ? 2 : 1"></td>
  </ng-container>

  <ng-container matColumnDef="rabat-okKundeVarenr">
    <td mat-cell *matCellDef="let posteringsLinje">
      <span>{{ posteringsLinje.rabat.okKundeVarenr }}</span>
    </td>
  </ng-container>

  <ng-container matColumnDef="rabat-produkt">
    <td mat-cell *matCellDef="let posteringsLinje" [attr.colspan]="_isExpanded ? 4 : 2">
      <div>{{ posteringsLinje.rabat.varenavn }}</div>
    </td>
  </ng-container>

  <ng-container matColumnDef="rabat-excl-moms">
    <td mat-cell *matCellDef="let posteringsLinje" class="align-right">
      <span>
        {{ -1 * posteringsLinje.rabat.rabatExclMoms | dkCurrency }}
      </span>
    </td>
  </ng-container>

  <ng-container matColumnDef="rabat-inkl-moms">
    <td mat-cell *matCellDef="let posteringsLinje" class="align-right">
      <span>
        {{ -1 * posteringsLinje.rabat.rabatInclMoms | dkCurrency }}
      </span>
    </td>
  </ng-container>

  <ng-container matColumnDef="rabat-row-menu">
    <td mat-cell *matCellDef="let posteringsLinje"></td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="headerColumns"></tr>
  <tr mat-header-row *matHeaderRowDef="activeColumns"></tr>
  <tr mat-row *matRowDef="let row; let i = index; columns: activeColumns" [class.product-with-rabat]="afregningHasRabat(row)"></tr>
  <tr mat-row *matRowDef="let row; let i = index; columns: activeRabatColumns; when: hasRabat" [class.rabat]="afregningHasRabat(row)"></tr>
  <tr mat-footer-row class="highlighted" *matFooterRowDef="activeColumns"></tr>
</table>
